import React from 'react';
import { withFormsy } from 'formsy-react';
import PropTypes from 'prop-types';
import Radium from 'radium';

const style = {
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  borderBottom: '2px solid #17E685',
  width: '100%',
  outline: 'none',
  padding: '5px',
};

class UnderlinedInput extends React.Component {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    this.props.setValue(event.currentTarget.value);
  }

  render() {
    let errorMessage = this.props.getErrorMessage();
    const { placeholder, getValue, name, validationMsg } = this.props;

    const error =
      !!this.props.showError() || (!this.props.isPristine() && this.props.showRequired());

    const errorStyle = error ? { borderBottom: '2px solid red' } : {};

    if (!this.props.isPristine() && this.props.showRequired()) {
      errorMessage = 'This field is required';
    }
    return (
      <div style={{ paddingBottom: '10px', position: 'relative' }}>
        <input
          onChange={this.changeValue}
          type="text"
          value={getValue()}
          style={[style, errorStyle]}
          placeholder={placeholder}
          name={name}
        />
        <span
          style={{
            color: 'red',
            fontSize: '12px',
            position: 'absolute',
            bottom: '-5px',
            left: '0px',
          }}
        >
          {errorMessage}
        </span>
      </div>
    );
  }
}

UnderlinedInput.defaultProps = {
  placeholder: '',
};

UnderlinedInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  getValue: PropTypes.func.isRequired,
  getErrorMessage: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default withFormsy(Radium(UnderlinedInput));



// WEBPACK FOOTER //
// ./src/components/Formsy/UnderlinedInput.js